function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 489.164 489.164"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M159.582 75.459v285.32c-14.274-10.374-32.573-16.616-52.5-16.616-45.491 0-82.5 32.523-82.5 72.5s37.009 72.5 82.5 72.5 82.5-32.523 82.5-72.5V168.942l245-60.615v184.416c-14.274-10.374-32.573-16.616-52.5-16.616-45.491 0-82.5 32.523-82.5 72.5s37.009 72.5 82.5 72.5 82.5-32.523 82.5-72.5V0l-305 75.459z",
  fill: "#595b5c"
})));